import React from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Breadcrumb from '../../components/Breadcrumb';
import ScrollToTop from '../../components/ScrollTop';
import { Link } from 'react-router-dom';

const CourseList = () => {

    const intelligences = [
        {
            id: 1,
            name: "Linguistic Intelligence",
            description: "Ability to use language effectively in speaking, writing, reading, and storytelling."
        },
        {
            id: 2,
            name: "Logical-Mathematical Intelligence",
            description: "Ability to reason, analyze patterns, solve problems, and work with numbers."
        },
        {
            id: 3,
            name: "Visual-Spatial Intelligence",
            description: "Capacity to think in images and visualize objects, designs, or spaces."
        },
        {
            id: 4,
            name: "Bodily-Kinesthetic Intelligence",
            description: "Skill in using the body for expression, sports, or hands-on activities."
        },
        {
            id: 5,
            name: "Musical Intelligence",
            description: "Ability to understand rhythm, tone, pitch, and musical patterns."
        },
        {
            id: 6,
            name: "Interpersonal Intelligence",
            description: "Ability to understand others, communicate effectively, and work in teams."
        },
        {
            id: 7,
            name: "Intrapersonal Intelligence",
            description: "Self-awareness and the ability to understand one's emotions and goals."
        },
        {
            id: 8,
            name: "Naturalistic Intelligence",
            description: "Sensitivity to nature, animals, plants, and environmental patterns."
        }
    ];

    return (
        <div className="courses-list-page">
            <Header
                parentMenu='course'
            />

            <div className="react-wrapper">
                <div className="react-wrapper-inner">
                    <Breadcrumb
                        pageTitle="Types of Intelligence"
                    />

                    <div className="back__course__page_grid pb---40 pt---100">
                        <div className="container pb---70">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="text-center mb---40">
                                        <h2>Multiple Intelligence Types</h2>
                                        <p>Discover the 8 dimensions of intelligence evaluated by MindMetric</p>
                                    </div>

                                    <div className="row">
                                        {intelligences.map((intelligence, index) => (
                                            <div key={index} className="col-lg-6 col-md-12 mb---30 wow animate__fadeInUp" data-wow-duration="0.3s">
                                                <div className="intelligence-card" style={{
                                                    padding: "25px",
                                                    border: "1px solid #e0e0e0",
                                                    borderRadius: "8px",
                                                    backgroundColor: "#f9f9f9",
                                                    transition: "all 0.3s ease"
                                                }}>
                                                    <h3 style={{marginBottom: "10px", color: "#333"}}>{intelligence.name}</h3>
                                                    <p style={{marginBottom: "15px", color: "#666", lineHeight: "1.6"}}>{intelligence.description}</p>
                                                    <Link to="/tests" style={{
                                                        color: "#007bff",
                                                        textDecoration: "none",
                                                        fontWeight: "600"
                                                    }}>
                                                        Learn More
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-arrow-right" style={{display: 'inline-block', marginLeft: '8px'}}>
                                                            <line x1="5" y1="12" x2="19" y2="12"></line>
                                                            <polyline points="12 5 19 12 12 19"></polyline>
                                                        </svg>
                                                    </Link>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* scrolltop-start */}
                    <ScrollToTop />
                    {/* scrolltop-end */}
                </div>
            </div>

            <Footer />

        </div>
    );
}


export default CourseList;

